import { render } from "./AddMenuItem.vue?vue&type=template&id=3c7f0fa9&scoped=true"
import script from "./AddMenuItem.vue?vue&type=script&lang=js"
export * from "./AddMenuItem.vue?vue&type=script&lang=js"

import "./AddMenuItem.vue?vue&type=style&index=0&id=3c7f0fa9&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7f0fa9"]])

export default __exports__